import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ComplianceSection from '../components/complianceSection';
import RejectionSection from '../components/rejectionSection';
import { Grid } from '@mui/material';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

export default function SettingsPage() {
  const [value, setValue] = React.useState('compliance');
  useDocumentTitle('Dashboard');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid>
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="settings tabs"
        >
          <Tab value="compliance" label="Compliance" />
          <Tab value="rejections" label="Rejections" />
        </Tabs>

        <Box sx={{ p: 2 }}>
          {value === 'compliance' && <ComplianceSection />}
          {value === 'rejections' && <RejectionSection />}
        </Box>
      </Box>
    </Grid>
  );
}
